import React, { PureComponent, createRef } from 'react';
import { Document } from 'react-pdf';
import { VariableSizeList } from 'react-window';
import styled from 'styled-components';
import * as Icons from '../Icons';
import PageRenderer from './PageRenderer';
const Styles = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
  background: ${(props) => props.theme.vLightGray};
  overflow: hidden;

  .document-lupe {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -16px;
    margin-left: -16px;
    z-index: 30;
  }
`;
const BlureLayer = styled.div `
  filter: blur(100px);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  background: #999;
  height: 100%;
  width: 100%;
`;
class BlurePDF extends PureComponent {
    constructor(props) {
        super(props);
        this.getContainerWidth = () => {
            const { current } = this._wrapperRef;
            if (!current) {
                return;
            }
            return current.clientWidth;
        };
        this.cachePageDimensions = (pdf) => {
            const promises = Array.from({ length: 1 }, (v, i) => i + 1).map((pageNumber) => pdf.getPage(pageNumber));
            Promise.all(promises).then((pages) => {
                const documnetWidth = this.getContainerWidth();
                const pageDimensions = new Map();
                for (const page of pages) {
                    const baseHeight = page.view[3];
                    const h = baseHeight;
                    pageDimensions.set(page.pageIndex + 1, [documnetWidth, h]);
                }
                this.setState({
                    cachedPageDimensions: pageDimensions,
                    containerHeight: 200,
                });
            });
        };
        this.recomputeRowHeights = () => {
            this._list.current.resetAfterIndex(0);
        };
        this.updatePageHeight = (index) => {
            return 200;
        };
        this.onDocumentLoadSuccess = (pdf) => {
            const { handleComplete } = this.props;
            this.setState({ pdf });
            this.cachePageDimensions(pdf);
            handleComplete();
        };
        this.updateCurrentVisiblePage = ({ visibleStopIndex }) => {
            this.setState({ visibleStopIndex });
        };
        this.handleResize = () => {
            this.setState({
                fakeUpdate: {},
            }, () => this.recomputeRowHeights());
        };
        this.state = {
            containerHeight: 200,
            pdf: null,
            currentPage: 1,
            cachedPageDimensions: null,
            responsiveScale: 1,
            pageNumbers: new Map(),
            pages: new WeakMap(),
        };
        this._list = createRef();
        this._wrapperRef = React.createRef();
    }
    render() {
        const { cachedPageDimensions, pdf, pages, pageNumbers, containerHeight } = this.state;
        const { dtbs, handleClick } = this.props;
        return (React.createElement(Styles, { className: "BlurePDF", ref: this._wrapperRef, onClick: () => handleClick() },
            React.createElement(Icons.Lupe, { className: "document-lupe", width: 32, height: 32, color: "#000" }),
            React.createElement(BlureLayer, null),
            React.createElement(Document, { file: dtbs.url, loading: "", onLoadSuccess: this.onDocumentLoadSuccess, onLoadError: (error) => console.error(error) }, cachedPageDimensions && (React.createElement(VariableSizeList, { height: containerHeight, itemCount: 1, itemSize: this.updatePageHeight, itemData: {
                    width: this.getContainerWidth(),
                    pages,
                    pageNumbers,
                    numPages: pdf.numPages,
                    triggerResize: () => this.handleResize(),
                }, overscanCount: 0, onItemsRendered: this.updateCurrentVisiblePage, ref: this._list }, PageRenderer)))));
    }
}
export default BlurePDF;
